import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
// import { Delete, Get, Patch, Post, Put } from "./RestClient.js";

export async function getPartner({
    name
}) {
    try {
        let partners = await axios.Get({
            url: `${adminUrl}/partners?name=${name || ''}`,
        });

        if (partners.statusCode !== 200) {
            return { error: partners.message };
        }

        return { data: partners.data };
    } catch (e) {
        return { error: e.response.data };
    }
}